"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _excluded = ["componentKey"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Dynamicly renders a layout with multiple zones
 * using the 'config' as configuration, 'order' array
 * as the lead and 'registry' as components' store
 * @param config
 * @returns Returns an array of React Elements
 */
var DynamicRenderer = function DynamicRenderer(_ref) {
  var registry = _ref.registry,
      order = _ref.order,
      dataConfig = _ref.dataConfig;
  return order.filter(function (key) {
    return !!dataConfig[key] && !!registry[dataConfig[key].componentKey];
  }).map(function (key) {
    var _dataConfig$key = dataConfig[key],
        componentKey = _dataConfig$key.componentKey,
        props = (0, _objectWithoutProperties2["default"])(_dataConfig$key, _excluded);
    var component = registry[componentKey];
    return component(_objectSpread(_objectSpread({}, props), {}, {
      key: key
    }));
  });
};

var _default = DynamicRenderer;
exports["default"] = _default;